import { Box, TableCell, TableRow, Typography } from '@mui/material';

const ErrorRow = ({ text }: { text: string }) => (
  <TableRow>
    <TableCell
      colSpan={9}
      sx={(theme) => ({
        textJustify: 'center',
        textAlign: 'center',
        paddingY: theme.spacing(4),
      })}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Typography
          sx={(theme) => ({
            backgroundColor: theme.colors.primary[50],
            color: theme.colors.primary[500],
            paddingX: theme.spacing(1.5),
            paddingY: theme.spacing(1),
            borderRadius: theme.spacing(0.5),
            fontWeight: 400,
          })}
        >
          {text}
        </Typography>
      </Box>
    </TableCell>
  </TableRow>
);

export default ErrorRow;
